import * as types from './actionTypes';  
import deleteOrderApi from '../api/deleteOrderApi';
import {logout} from '../helper/helper';
import { getItem } from '../utils/localStore';
import Swal from 'sweetalert2'

export function deleteOrder(data) {
  return {
    type: types.DO_DELETE_ORDER, 
    data
  };
}

export function dodeleteOrderRes(data) {
  return {
    type: types.DO_DELETE_ORDER_RES, 
    data
  };
}

export function delete_order(data) {
  const TOKEN = getItem('auth_token');
  if(TOKEN){
    return function(dispatch) {
      deleteOrderApi.deleteOrder(data).then(data => {
        dispatch(dodeleteOrderRes(data));
        dispatch(dodeleteOrderRes(null));
        if(data.error){
          Swal.fire({
            title: data.message,
            icon: 'error',
            confirmButtonText: 'OK',
            allowOutsideClick: false,
            timer: 3000,
            heightAuto: false
          })
        }
      }).catch(error => {
        return error
      });
    };
  }else{
    logout()
  }
}